import { render, staticRenderFns } from "./OzCenterModal.vue?vue&type=template&id=e55b5e10&scoped=true&"
import script from "./OzCenterModal.vue?vue&type=script&lang=ts&"
export * from "./OzCenterModal.vue?vue&type=script&lang=ts&"
import style0 from "./OzCenterModal.vue?vue&type=style&index=0&id=e55b5e10&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55b5e10",
  null
  
)

export default component.exports